<template>
  <div id="container">

      <h3 class="content-block openware-form-title">{{ title }}</h3>

      <DxPopup
          :drag-enabled="false"
          :hide-on-outside-click="true"
          :show-close-button="true"
          :show-title="true"
          v-model:visible="isPopupVisible"
          title="Διαχείριση Ναύλου"
          :width="'90%'" 
          :height="'90%'"
          :toolbar-items="[
                          {
                              widget: 'dxButton',
                              location: 'after',
                              options: {
                                  icon: 'help', 
                                  onClick: () => {
                                      this.isPopoverVisible = !this.isPopoverVisible;
                                  },
                                  elementAttr: {
                                      id: 'help-button'
                                  }
                              }
                          }
                      ]"
          deferRendering="true"
          :animation="{
                        show: {
                            type: 'pop',
                            duration: 800,
                            from: {
                                scale: 0.90
                            }
                        }, 
                      }"
      >
          <DxScrollView height="100%" width="100%">
              <CharterAgreementForm
                  :charter_agreement_code="selectedCharterAgreementCode" 
                  @closePopupEvent="onClosePopupEmit">
              </CharterAgreementForm>
          </DxScrollView>
      </DxPopup>


      <DxDataGrid
          :key-expr="id"
          :data-source="CustomStoreMain"

          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :column-auto-width="true"
          :show-borders="true"
          :show-column-lines="true"
          :show-row-lines="true"
          :row-alternation-enabled="true"
          :focused-row-enabled="true"
          :selection-mode="'single'"
          ref="dataGridRefKey"
          :word-wrap-enabled="true"

          @exporting="onExporting"
          @selectionChanged="onSelectionChanged"
          @init-new-row="onCustomInitNewRow"
          @row-dbl-click="onRowDoubleClick"
      >

          <DxSelection mode="single" />

          <DxEditing
              :allow-updating="true"
              :allow-adding="true"
              :allow-deleting="true"
          />

          <template #filterClear>
              <DxBtn
                :width="5"
                type="default"
                icon="clearformat"
                styling-mode="outlined"
                hint="Καθαρισμός Φίλτρων"
                @click="onFilterClearClick"
              />
          </template>

          <template #filterYearTemplate>
              <DxLookup
                  v-model:value="selectedYear"
                  :data-source="CustomStoreLOOKUP_serres_view_years"
                  value-expr="working_year"
                  display-expr="working_year"
                  placeholder="Έτος ναύλου"
                  :show-clear-button="true"
                  @value-changed="onValueChangedworking_year"
              >
              </DxLookup>
          </template>

          <template #filterFutureChartersTemplate>
              <DxCheckBox
                v-model:value="isFutureCharters"
                text="Μόνο μελλοντικά ναύλα"
                @value-changed="onValueChangedisFutureCharters"
              />
          </template>

          <template #filterActiveChartersTemplate>
              <DxCheckBox
                v-model:value="isActiveCharters"
                text="Μόνο ενεργά ναύλα"
                @value-changed="onValueChangedisActiveCharters"
              />
          </template>

          <DxToolbar>
              <DxItem  
                  location="after" 
                  name="groupPanel" 
              />

              <DxItem 
                  name="columnChooserButton" 
              />

              <DxItem
                  location="before"
                  template="filterClear"
              />

              <DxItem
                  location="before"
                  template="filterYearTemplate"
              />

              <DxItem
                  location="before"
                  template="filterFutureChartersTemplate"
              />

              <DxItem
                  location="before"
                  template="filterActiveChartersTemplate"
              />

              <DxItem
                  location="before"
                  name="searchPanel"
              />

              <DxItem location="after" 
                        widget="dxButton" 
                        :options="{
                            icon: 'add',
                            text: '',
                            hint: 'Προσθήκη',
                            onClick: () => {
                                this.onCustomInitNewRow()
                            }
                        }"
              />

              <DxItem name="exportButton" 
                  :options="{
                          hint: 'Εξαγωγή δεδομένων'
                      }"
              />
          </DxToolbar>

          <DxPaging 
              :enabled="true"
              :page-size="5"
          />

          <DxFilterRow :visible="true"/>
          <DxHeaderFilter :visible="true"/>
          
          <DxPager
              :visible="true"
              :allowed-page-sizes="pageSizes"
              :display-mode="displayMode"
              :show-page-size-selector="true"
              :show-info="true"
              :show-navigation-buttons="true"
          />

          <DxGrouping :context-menu-enabled="true"/>
          <DxGroupPanel :visible="true"/>

          <DxSorting mode="multiple"/>

          <DxSearchPanel 
              placeholder="Αναζήτηση" 
              visible="true"
              :width="'30vw'"
              ref="searchPanelRefKey"
          />

          <DxColumnChooser
              :visible="isColumnVisible"
          >
            <DxPosition
                my="right top"
                at="right bottom"
                of=".dx-treelist-column-chooser-button"
            />
            <DxColumnChooserSearch
                :enabled="searchEnabled"
                :editor-options="editorOptions"
            />
            <DxColumnChooserSelection
                :allow-select-all="allowSelectAll"
                :select-by-click="selectByClick"
                :recursive="recursive"
            />
          </DxColumnChooser>

          <DxColumn type="buttons">
              <DxButton 
                  text="Επεξεργασία"
                  icon="edit"
                  hint="Επεξεργασία"
                  :on-click="onCustomRowEdit"
              />
              <!--<DxButton name="delete" hint="Διαγραφή"/>-->
          >
          </DxColumn>

          <DxColumn
              data-field="ow_active_ind"
              caption="Ενεργός"
              width="90"
          >
          </DxColumn>

          <DxColumn
              data-field="charter_agreement_code"
              caption="ID"
              sort-order="desc"
              width="70"
          >
          </DxColumn>

          <DxColumn
              data-field="days_to_charter"
              caption="Ημέρες ως την Απ/ση"
              width="90"
              :allow-grouping="true"
          >
          </DxColumn>

          <DxColumn
              data-field="charter_agreement_id"
              caption="Κωδικός Ναυλοσυμφώνου"
              width="100"
          >
          </DxColumn>

          <DxColumn
              data-field="charter_party_date"
              caption="Ημερομηνία Ναυλοσυμφώνου"
              data-type="date"
              format="dd/MM/yyyy"
              width="100"
          >
          </DxColumn>

          <DxColumn
              data-field="charterer_name"
              caption="Όνομα Ναυλωτή"
          >
          </DxColumn>

          <DxColumn
              data-field="country"
              caption="Χώρα"
          >
          </DxColumn>

          <DxColumn
              data-field="vessel_name"
              caption="Όνομα Σκάφους"
          >
          </DxColumn>

          <DxColumn
              data-field="vessel_type"
              caption="Τύπος Σκάφους"
          >
          </DxColumn>

          <DxColumn
              data-field="charter_period_from_date"
              caption="Ημερομηνία Επιβίβασης"
              data-type="date"
              format="dd/MM/yyyy"
          >
          </DxColumn>

          <DxColumn
              data-field="charter_period_to_date"
              caption="Ημερομηνία Αποβίβασης"
              data-type="date"
              format="dd/MM/yyyy"
          >
          </DxColumn>

          <DxColumn
              data-field="charter_embarkation_port"
              caption="Embarkation Port"
          >
          </DxColumn>

          <DxColumn
              data-field="charter_disembarkation_port"
              caption="Dismbarkation Port"
          >
          </DxColumn>

          <DxColumn
              data-field="charter_skipper_name"
              caption="Όνομα Skipper"
          >
          </DxColumn>

          <DxColumn
              data-field="charter_skipper_fee"
              caption="Αμοιβή Skipper"
          >
          </DxColumn>
          
          <DxColumn
              data-field="vessel_owner_name"
              caption="Όνομα Πλοιοκτήτη"
          >
          </DxColumn>

          <DxColumn
              data-field="vessel_representative_name"
              caption="Όνομα Εκπροσώπου"
          >
          </DxColumn>

          <DxColumn
              data-field="broker_gr_name"
              caption="Πράκτορας"
          >
          </DxColumn>

          <DxColumn
              data-field="broker_abroad_name"
              caption="Πράκτορας 2"
          >
          </DxColumn>

          <DxColumn
              data-field="client_agreement"
              caption="Client Agreement"
              data-type="number"
              :format="formatCurrency"
              v-model:visible="isColumnVisible"
          >
          </DxColumn>
          
          <DxColumn
              data-field="provider_agreement"
              caption="Provider Agreement"
              data-type="number"
              :format="formatCurrency"
              v-model:visible="isColumnVisible"
          >
          </DxColumn>

          <DxColumn
              data-field="charter_profit"
              caption="Δ"
              data-type="number"
              :format="formatCurrency"
              v-model:visible="isColumnVisible"
          >
          </DxColumn>

          <DxColumn
              data-field="client_realized"
              caption="Client Realized"
              data-type="number"
              :format="formatCurrency"
              v-model:visible="isColumnVisible"
          >
          </DxColumn>

          <DxColumn
              data-field="provider_realized"
              caption="Provider Realized"
              data-type="number"
              :format="formatCurrency"
              v-model:visible="isColumnVisible"
          >
          </DxColumn>


          <DxColumn
              data-field="profit_realized"
              caption="Δ Realized"
              data-type="number"
              :format="formatCurrency"
              v-model:visible="isColumnVisible"
          >
          </DxColumn>

          <DxSummary>
            <DxTotalItem
              column="client_agreement"
              summary-type="sum"
              :value-format="formatCurrency"
              display-format="{0}"
            />
            <DxTotalItem
              column="provider_agreement"
              summary-type="sum"
              :value-format="formatCurrency"
              display-format="{0}"
            />
            <DxTotalItem
              column="charter_profit"
              summary-type="sum"
              :value-format="formatCurrency"
              display-format="{0}"
            />
            <DxTotalItem
              column="client_realized"
              summary-type="sum"
              :value-format="formatCurrency"
              display-format="{0}"
            />
            <DxTotalItem
              column="provider_realized"
              summary-type="sum"
              :value-format="formatCurrency"
              display-format="{0}"
            />
            <DxTotalItem
              column="profit_realized"
              summary-type="sum"
              :value-format="formatCurrency"
              display-format="{0}"
            />

          </DxSummary>

          <DxExport
              :enabled="true"
              :formats="['pdf', 'xlsx']"
              :texts= "{
                      exportAll: 'Εξαγωγή σε {0}',
                  }"
          />


      </DxDataGrid>
      </div>
</template>

<script>

const DATAGRIDREFKEY = 'my-data-grid';
const URL_SERVICE = NYParameters.Host.URI + 'serres_view_charter_agreement';
const URL_LOOKUP_serres_view_years = NYParameters.Host.URI + 'serres_view_years';

import DxDataGrid, {
  DxColumn,
  DxButton,
  DxEditing, 
  DxPaging,
  DxPager,
  DxGroupPanel,
  DxSorting,
  DxFilterRow,
  DxHeaderFilter,
  DxExport,
  DxSelection,
  //DxLookup,
  DxToolbar,
  DxItem,
  DxSummary, 
  //DxGroupItem,
  DxTotalItem,
  DxGrouping,
  DxSearchPanel

} from 'devextreme-vue/data-grid';

import {DxButton as DxBtn}  from 'devextreme-vue/button';

import { DxCheckBox } from 'devextreme-vue/check-box';

import {
  DxColumnChooser, 
  DxColumnChooserSearch, 
  DxColumnChooserSelection,
  DxPosition,
} from 'devextreme-vue/tree-list';

import { DxLookup } from 'devextreme-vue/lookup';

import DxScrollView from 'devextreme-vue/scroll-view';
import DxPopup from 'devextreme-vue/popup';

import CustomStore from 'devextreme/data/custom_store';
import 'whatwg-fetch';

import CharterAgreementForm from './ny-charter-agreement-form.vue';

import NYParameters from '../../ny-globals';

export default {
      components: {

        CharterAgreementForm,

        DxDataGrid,
        DxColumn,
        DxButton,
        DxEditing, 
        DxPaging,
        DxPager,
        DxGroupPanel,
        DxSorting,
        DxFilterRow, 
        DxHeaderFilter,
        DxExport,
        DxPopup,
        //DxLookup,
        DxScrollView,
        DxSelection,
        DxToolbar,
        DxItem,
        DxSummary, 
        //DxGroupItem,
        DxTotalItem,
        DxGrouping,
        DxLookup,
        DxSearchPanel,
        DxColumnChooser, 
        DxColumnChooserSearch, 
        DxColumnChooserSelection,
        DxPosition,
        DxCheckBox,
        DxBtn
  },  
  mounted() {
    // Your code to run after the page loads
    this.isColumnVisible = NYParameters.loggedUser.is_administrator == 1
    this.prepareFilter()
  },
  data() {
      return {
          IPPattern: "^((25[0-5]|(2[0-4]|1\\d|[1-9]|)\\d)\\.?\\b){4}$",
          CustomStoreMain: new CustomStore({
              key: 'charter_agreement_code',
              //loadMode: 'raw',
              load: () => this.sendRequest(URL_SERVICE + this.filterGrid),
              byKey: (key) => this.sendRequest(URL_SERVICE + "/" + encodeURIComponent(key)),
          }),

          CustomStoreLOOKUP_serres_view_years: new CustomStore({
              key: 'id',
              //loadMode: 'raw',
              load: () => this.sendRequest(URL_LOOKUP_serres_view_years + '?order=id,desc'),
              byKey: (key) => this.sendRequestByKey(URL_LOOKUP_serres_view_years + '/' + encodeURIComponent(key)),
          }),

          isPopupVisible: false,
          isPopoverVisible: false,
          selectedYear: new Date().getFullYear(),
          isFutureCharters: true, 
          isActiveCharters: true,
          filterGrid: "",
          isColumnVisible: false,

          formatCurrency: { 
                            type: 'currency',
                            currency: 'EUR', 
                            useGrouping: true, 
                            precision: 2 
                        },

          //selectedCharterAgreementCode: 21,
          title: 'Ναύλα',
          pageSizes: [5, 10, 20],
          dataGridRefKey: DATAGRIDREFKEY,
          toolbarOptions: {
              items: [
                  {
                      widget: 'dxButton',
                      options: {
                          icon: 'add',
                          text: 'Προσθηκη',
                          onClick: () => {
                              this.onCustomInitNewRow()
                          }
                      }
                  }
              ]
          }
      };
  }, 
  
  methods: {
      // 
      //  Based on: https://js.devexpress.com/Demos/WidgetsGallery/Demo/DataGrid/CRUDOperations/Vue/GreenMist/
      //
      async sendRequest(url, method = 'GET', values = {}) {
          // console.log('LOG: ' + url + ' METHOD: ' + method + ' VALUES: ' + JSON.stringify(values, null, 4));
          if (method === 'GET') {
              const response = await fetch(url, {
                method,
                credentials: 'include',
              });
              const json = await response.json();
              if (response.ok) return json.records;
              throw json.Message;
          }

          const result_1 = await fetch(url, {
              method,
              body: JSON.stringify(values),
              headers: {
                'Content-Type': 'application/json', //'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
              },
              credentials: 'include',
          });

          if (result_1.ok) {
            return result_1.text().then((text) => text && JSON.parse(text));
          }
          const json_1 = await result_1.json();
          throw json_1.Message;
      },

      async sendRequestByKey(url, method = 'GET') {
          //console.log('LOG: ' + url + ' METHOD: ' + method + ' VALUES: ' + JSON.stringify(values, null, 4));
          const response = await fetch(url, {
            method,
            headers: {
              'Accept': 'application/json',
            },
            credentials: 'include',
          });
          return await response.json();
      },

      onValueChangedworking_year(e) {
          this.selectedYear = e.value
          this.prepareFilter()
          this.applyFilter()
      },

      onFilterClearClick() {
          this.selectedYear = ""
          this.$refs.dataGridRefKey.instance.clearFilter()
      },
      
      onValueChangedisFutureCharters(e) {
          this.isFutureCharters = e.value
          this.prepareFilter()
          this.applyFilter()
      },

      onValueChangedisActiveCharters(e) {
          this.isActiveCharters = e.value
          this.prepareFilter()
          this.applyFilter()
      },

      prepareFilter() {
          if (NYParameters.loggedUser.is_nautiliasalesgroup == 1) {
            this.filterGrid = '?filter=user_id_allowed,eq,' + NYParameters.loggedUser.system_user_id
          }

          if (NYParameters.loggedUser.is_nautiliaofficegroup == 1) {
            this.filterGrid = '?filter=charter_period_to_date,ge,' + new Date().toISOString().split('T')[0] + '&filter=ow_active_ind,eq,1'
          }

          if (NYParameters.loggedUser.is_administrator == 1) {
            this.filterGrid = "?filter=charter_agreement_code,gt,0"
          }

          if (this.selectedYear != "" && this.selectedYear !== undefined && this.selectedYear !== null) {
              this.filterGrid += '&filter=ny_charter_party_year,eq,' + this.selectedYear
          }
          if (this.isActiveCharters) {
              this.filterGrid += '&filter=ow_active_ind,eq,1'
          }
          if (this.isFutureCharters) {
              this.filterGrid += '&filter=charter_period_to_date,ge,' + new Date().toISOString().split('T')[0]
          }
          //console.log(this.filterGrid)
      },

      async applyFilter() {
          await this.$refs.dataGridRefKey.instance.refresh()
      },

      onRowDoubleClick(e) {
          console.log("onRowDoubleClick")
          console.log(e)
          this.selectedCharterAgreementCode = e.key;
          this.isPopupVisible = true;
      },

      onSelectionChanged(e) {
          this.selectedCharterAgreementCode = e.currentSelectedRowKeys[0];
      },
      onClosePopupEmit() {
          this.isPopupVisible = false;
          this.dataGrid.refresh();
      },
      onOpenForm(e) {
        this.$refs.form.open(e.data);
      },
      onCustomInitNewRow() {
          this.isPopupVisible = true;
          this.selectedCharterAgreementCode = null;
      },
      onCustomRowEdit(e) {
          this.selectedCharterAgreementCode = e.row.key;
          this.isPopupVisible = true;
      },
      onExporting (e){
          NYParameters.methods.exportDataGridToPdfExcel(e, this.title)
      },
  },
  computed: {
      dataGrid: function() {
          return this.$refs[DATAGRIDREFKEY].instance;
      }
  },
};
</script>

<style scoped>
  .options {
    padding: 20px;
    margin-top: 20px;
    background-color: rgba(191, 191, 191, 0.15);
  }
  .caption {
    font-size: 18px;
    font-weight: 500;
  }
  .option {
    margin-top: 10px;
  }
  .dx-toolbar {
    padding: 10px 0 10px 15px;
  }
  .dx-button-has-icon .dx-button-content .dx-icon {
    padding: 6px;
  }
</style>